module.exports = __webpack_public_path__ + "26d5f8bd6f5efe0cbbf93f31ad90ccbf.png";